module.exports = __webpack_public_path__ + "static/img/__2105.7e689c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__2105.jpg
// module id = QKXW
// module chunks = 0